import { interceptExternalLinks } from "config";
import { isToddleAppSubdomain } from "Utils";

const isValidHttpUrl = url => {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.protocol === "http:" || parsedUrl.protocol === "https:";
  } catch (e) {
    console.error("Invalid URL:", url, e);
    return false;
  }
};

const validateURL = url => {
  // skip interception if disabled in config
  // or if non-http(s) urls like mailto:, tel:, etc.
  if (!interceptExternalLinks || !isValidHttpUrl(url)) {
    return true;
  }

  const isExternal = !isToddleAppSubdomain(url);

  if (!isExternal) {
    return true;
  }

  const userConfirmed = window.confirm(
    `You are about to leave Toddle and navigate to an external site:\n\n${url}\n\nDo you want to continue?`
  );

  return userConfirmed;
};

export function setupNavigationInterception() {
  if (window.__isExternalLinkInterceptorAdded) return;
  window.__isExternalLinkInterceptorAdded = true;

  const allow = url => validateURL(url);

  // replace the window.open method to intercept programmatic opens
  // eslint-disable-next-line no-restricted-properties
  const originalOpen = window.open;
  // eslint-disable-next-line no-restricted-properties
  window.open = function (url, ...args) {
    try {
      if (allow(url)) return originalOpen.call(window, url, ...args);
      return null;
    } catch (error) {
      console.error("Error in navigation interception:", error);
      // in case of error, prevent navigation to maintain security
      return null;
    }
  };

  // Intercept anchor tag clicks
  document.addEventListener(
    "click",
    e => {
      try {
        const anchor = e.target.closest("a");
        if (!anchor) return;

        const href = anchor.getAttribute("href");

        // intercept links but allow only if validated
        // conditions:
        // 1. toddleapp.com/.cn domain/subdomain links
        // 2. links such as mailto:, tel: etc.
        if (href && !allow(href)) {
          e.preventDefault();
          e.stopPropagation();
        }
      } catch (error) {
        console.error("Error in anchor click interception:", error);
        // in case of error, prevent navigation to maintain security
        e.preventDefault();
        e.stopPropagation();
      }
    },
    true
  );
}
